import { createSelector } from 'reselect';
import { loadStorage } from '../Utils/Utils';

export const selectUserDetails = (store) => {
    return store.user.data || loadStorage("user");
}

export const selectCartDetails = (store) => {
    return store.cart.data
}

export const selectProductDetails = (store) => {
    return store?.products?.data
}


export const selectProduct = createSelector(
  selectProductDetails,
  (productDetails) => (id) => {
    if (productDetails && productDetails.length > 0 && id) {
      return productDetails.find((item) => item.id === id);
    }
    return null;
  }
);


// export const selectAllProducts = createSelector(selectProductDetails, (productDetails) => {
//     if (productDetails) {
//         return productDetails.map((product) => {
//             return {
//                 name: product.name,
//                 price: product.price,
//                 image: ConvertBytesToImage(product?.image),
//                 category: product.Category,
//                 subCategory: product.subCategory,
//                 description: product.description
//             }
//         })
//     }
//     return null;
// });

export const selectCartProductDetails = createSelector([selectCartDetails, selectProductDetails], (cartDetails, productDetails) => {
    if (cartDetails?.length > 0 && productDetails.length > 0) {
        return cartDetails.map((cart) => {
            let product = productDetails.find((p) => p.id === cart.productId);
            return {
                cartId: cart.cartId,
                quantity: cart.quantity,
                productName: product.name,
                price: product.price * cart.quantity,
                image: product.image,
                productId: cart.productId,
                stockQuantity: product.stockQuantity ?? 0,
            }
        });
    }
    return null;
});

export const selectCartTotalAmount = createSelector(selectCartProductDetails, (cartProductDetails) => {
    if (cartProductDetails?.length > 0) {
        return cartProductDetails.reduce(function (accumulator, product) {
            return accumulator + Number(product.price);
        }, 0).toFixed(2);
    }
    return 0;
});
